

import { useState } from 'react';
import { Link } from 'react-router-dom';

const FeatureSubmenuLinkItem = ({href,title, description,icon,onHoverIcon}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Link to={href}>
      <div
        className='flex  gap-4 py-4 px-0 md:p-4 hover:bg-[#1D1D20] hover:rounded-2xl'
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div >
         { !isHovered && <img className='h-[32px] w-[39px]' src={icon} alt='feature dropdwon link item icon' />}
         {isHovered &&  <img className='h-[32px] w-[39px]' src={onHoverIcon} alt='feature dropdwon link item icon' />}
        </div>
        <div>
          <h6 className={`mb-2 `}>{title}</h6>
          <span className='text-[1.1rem] font-medium text-[#595959] inline-block w-[90%]'>{description}</span>
        </div>
      </div>
    </Link>
  );
};

export default FeatureSubmenuLinkItem;


